import { useQuery } from "@tanstack/react-query";

import { MDS_COUNTRY_ISD_URL, ONE_HOUR } from "constants/constants";

const trimString = (value) => (value == null ? "" : String(value).trim());

const getCountryDetails = (item) =>
  item && typeof item.details === "object" ? item.details : null;

const getPrimaryIsdCode = (details) =>
  trimString(details?.isd_codes?.[0]?.code);

export const mapCountryMappingsToIsdList = (response) => {
  if (!Array.isArray(response?.items) || response.items.length === 0) {
    return [];
  }

  return response.items
    .map((item) => {
      if (item?.id == null) {
        return null;
      }

      const details = getCountryDetails(item);
      if (!details) {
        return null;
      }

      const countryCode = trimString(details.code).toUpperCase();
      const displayName = trimString(details.display_name);
      const countryName = trimString(details.name).toUpperCase();
      const isdCode = getPrimaryIsdCode(details);

      if (!countryCode || !displayName || !countryName || !isdCode) {
        return null;
      }

      return {
        country_id: item.id,
        country_code: countryCode,
        isd_code: isdCode,
        display_name: displayName,
        country_name: countryName,
        value: isdCode,
        label: isdCode,
      };
    })
    .filter(Boolean);
};

export const getCountryIsdList = async () => {
  if (!MDS_COUNTRY_ISD_URL) {
    throw new Error("MDS country ISD URL is not configured");
  }

  const response = await fetch(MDS_COUNTRY_ISD_URL, {
    method: "POST",
    headers: {
      accept: "application/json",
    },
  });

  if (!response.ok) {
    throw new Error("Failed to fetch country ISD list");
  }

  const data = await response.json();
  const countryIsdList = mapCountryMappingsToIsdList(data);

  if (!countryIsdList.length) {
    throw new Error("No country ISD mappings found");
  }

  return countryIsdList;
};

export const useCountryIsdList = () =>
  useQuery({
    queryKey: ["mds", "country-isd-list"],
    queryFn: getCountryIsdList,
    enabled: Boolean(MDS_COUNTRY_ISD_URL),
    staleTime: ONE_HOUR * 24,
  });
